var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v("Language")]),
      _c(
        "md-input-container",
        [
          _c("label", [_vm._v("Language")]),
          _c(
            "md-select",
            {
              attrs: { id: "input-language" },
              model: {
                value: _vm.entity.language,
                callback: function($$v) {
                  _vm.$set(_vm.entity, "language", $$v)
                },
                expression: "entity.language"
              }
            },
            _vm._l(_vm.languageNames, function(name, code) {
              return _c("md-option", { key: code, attrs: { value: code } }, [
                _vm._v(_vm._s(name))
              ])
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13f28d74", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13f28d74","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/LanguageForm.vue
// module id = 976
// module chunks = 0